import React, { useEffect, useMemo } from "react";
import GridHolder from "../../../Reusable/Grid/GridHolder.js";
import LightBoxManager from "../../../Structure/LightBoxManager/LightBoxManager.js";
import { useMail } from "../../../../contexts/mailContext/mailContext.js";
import NoFilesComponent from "./NoFIlesComponent.js";
import { useMailView } from "contexts/mailViewContext/mailViewContext.js";

const ContentBody = () => {
  return (
    <div className={`content-body`}>
      <LightBoxManager />
      <GridHolder />
    </div>
  );
};

const ContentWrapper = () => {
  const {
    getFoldersData,
    getCurrentFolder,
    getMailMetaData,
    getFilesData,
    getSearchParam,
    setFilesList,
    getFolderStructured,
    getCurrentCollection,
    getFilesLoading,
  } = useMail();

  const { getGridView } = useMailView();

  useEffect(() => {
    if (Object.keys(getFilesData()).length > 0) {
      setFilesList();
    }
  }, [getFilesData(), getFoldersData()]);

  const conditionNoFiles =
    // if currect collection selected files exist for sure, cos user cant select collection if there are 0 files
    !getCurrentCollection() &&
    // 1. If no folder selected (root folder) and this root folder exist in data and has no files
    // and UI is folder structured in grid view
    ((!getCurrentFolder() &&
      getFoldersData()[1] &&
      !getFoldersData()[1].haveFiles &&
      getFolderStructured() &&
      getGridView()) ||
      // 2. If some folder selected but this folder dont have any files and UI is gridView and no folderstructured
      (getCurrentFolder() &&
        !getFoldersData()[getCurrentFolder()]?.haveFiles &&
        (getGridView() || !getFolderStructured())) ||
      // ??
      (getMailMetaData().filesCount === 1 &&
        Object.keys(getFilesData()).length === 0) ||
      // if user did search and response is empty
      (getSearchParam().length > 0 &&
        Object.keys(getFilesData()).length === 0));

  return useMemo(
    () =>
      conditionNoFiles ? (
        <NoFilesComponent searchString={getSearchParam()} />
      ) : (
        <ContentBody />
      ),
    [getCurrentFolder(), getFilesData(), conditionNoFiles, getFilesLoading()]
  );
};

export default ContentWrapper;
